module.exports = __webpack_public_path__ + "static/wpack/extracted/news-techreview2656bb132bb750ecd6bc322e36abadc0.png";